import { Role } from '../models/classes/users/Role';
import { __ } from './object.functions';

export class RoleHelper {
  static Roles: any[] = [
    {
      displayName: 'Company Administrator',
      value: Role.CompanyAdministrator
    },
    {
      displayName: 'Administrator',
      value: Role.Administrator
    },
    {
      displayName: 'User',
      value: Role.User
    },
    {
      displayName: 'Owner',
      value: Role.Owner
    }
  ];

  static GetExtendedRoleByNameOrNull(displayName: string): any {
    const result = RoleHelper.Roles.find((status: any) => status.value === displayName);
    if (__.IsNullOrUndefinedOrEmpty(result)) {
      return null;
    }
    return result;
  }

  static GetExtendedRoleByValueOrNull(value: Role | string): any {
    const result = RoleHelper.Roles.find((status: any) => status.value === value);
    if (__.IsNullOrUndefinedOrEmpty(result)) {
      return null;
    }
    return result;
  }
}
